// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"115356d3","382":"8e6fad74","419":"1418cd89"}[chunkId] + ".chunk.js";
};